import { type CourierDispatchJob } from '@vello/api-client';
import { useVocab } from './vocab';

/**
 * D577: where a courier job is, in words — the courier's own step while the job is assigned and the courier holds it, else the
 * dispatch status of the job. Both are catalog vocabularies; nothing is read from stored text.
 */
export function useCourierStep(): (job: Pick<CourierDispatchJob, 'dispatchStatus' | 'engagementState'>) => string {
  const { v, has } = useVocab();
  return (job) =>
    job.dispatchStatus === 'ASSIGNED' && job.engagementState !== null && has('courier.engagement_state', job.engagementState)
      ? v('courier.engagement_state', job.engagementState)
      : v('courier.dispatch_status', job.dispatchStatus);
}
